import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { withStyles } from '@material-ui/core/styles';

import Button from 'components/Button/Button';

const styles = theme => ({
  button: {
    marginTop: theme.spacing(1 / 2.5),
    marginBottom: theme.spacing(1 / 2.5),
  },
});

function Navigate(props) {
  const { classes, home } = props;
  const { t } = useTranslation('common');

  return (
    <div>
      <Button
        className={classes.button}
        data-testid="home"
        fullWidth
        onClick={home}
        variant="contained" color="primary"
      >
        {t('auth.back')}
      </Button>
    </div>
  )
}

Navigate.propTypes = {
  classes: PropTypes.object.isRequired,
  home: PropTypes.func.isRequired,
};

export default withStyles(styles)(Navigate)